import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

export default function ProtectedRoute({ children, adminOnly }) {
  const { user, setUser } = useAuth();
  const [checking, setChecking] = useState(!user);

  useEffect(() => {
    if (!user) {
      // Try to fetch the current user profile from backend
      axios.get(`${process.env.REACT_APP_API_URL}/api/user/profile`)
        .then(res => {
          setUser(res.data);
          localStorage.setItem('user', JSON.stringify(res.data));
        })
        .catch(() => {
          // Not logged in – stay on login page
        })
        .finally(() => setChecking(false));
    }
  }, []);

  if (checking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-black border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly) {
    const isAdmin = user.role === 'ADMIN';
    if (!isAdmin) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}